import React, { memo, useMemo } from "react"
import { Box, Button, Flex, Text } from "@chakra-ui/react"

import { useConfigContext } from "@app/providers/config"
import { useCore } from "@app/hooks/useCore"
import { Link } from "@app/components/Link"
import { ProductSizing } from "@app/components/Product/Sizing/ProductSizing"

import type { ProductProps, ProductCombinedProps } from "@root/types/global"

type Props = {
  grouped?: Array<ProductProps>
  product: ProductCombinedProps
}

export const ProductFormGrouped: React.FC<Props> = memo(({ grouped, product }) => {
  const {
    settings: { routes },
  } = useConfigContext()
  const {
    helpers: { capitalise },
  } = useCore()

  const name = useMemo(() => capitalise(product.options?.[0]?.name), [capitalise, product.options])
  const selectedTitle = product?.variants?.[0]?.title

  return grouped && grouped?.length > 1 && product.variants?.length === 1 ? (
    <Box>
      <Flex justify="space-between" mb={2}>
        <Text size="sm" letterSpacing="generous">{`${name}: ${selectedTitle}`}</Text>
        <ProductSizing product={product} />
      </Flex>
      <Flex wrap="wrap" gap={4}>
        {grouped.map(({ handle, variants }) => {
          const label = `${variants?.[0]?.title} - $${parseInt(variants?.[0]?.priceV2 as unknown as string)}`
          const isAvailable = variants?.find(variant => variant.availableForSale)
          const isActive = product.handle === handle
          const linkUrl = `${routes.PRODUCT}/${handle}`
          return (
            <Button variant="variantSelector" key={handle} isDisabled={!isAvailable} isActive={isActive} as={Link} to={linkUrl}>
              {label}
            </Button>
          )
        })}
      </Flex>
    </Box>
  ) : null
})
